var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgSymbolCurrent = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M25.472 34.817v9.782L8.6 34.82v-9.783l8.436-4.89-8.436-4.89V5.472l16.872 9.78v9.783l-8.436 4.89 8.436 4.89Zm0 9.782 7.298-4.23a2.292 2.292 0 0 0 1.138-1.984v-7.134c0-.82-.434-1.576-1.138-1.984l-7.298-4.23 7.298-4.232a2.292 2.292 0 0 0 1.138-1.983v-7.135c0-.819-.434-1.575-1.138-1.983L18.166 1.238a2.252 2.252 0 0 0-2.26 0L8.6 5.473l-7.298 4.23a2.292 2.292 0 0 0-1.138 1.984v7.135c0 .819.434 1.575 1.138 1.983L8.6 25.036l-7.298 4.23a2.292 2.292 0 0 0-1.138 1.985v7.134c0 .819.434 1.576 1.138 1.984l14.604 8.465c.7.406 1.56.406 2.26 0l7.306-4.235Z",
    clipRule: "evenodd"
  })));
});
SvgSymbolCurrent.displayName = "SvgSymbolCurrent";
export default SvgSymbolCurrent;